import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5b82a5c3"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#fff"
  }
}, "BIEL")], -1));
const _hoisted_2 = {
  class: "action menu-fold"
};
const _hoisted_3 = {
  style: {
    "float": "right",
    "margin-right": "20px"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-grow"
}, null, -1));
import { useStore } from 'vuex';
import { computed, ref, onBeforeMount } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { AppMain, TagsView } from './components';
import { ElMessageBox } from 'element-plus';
import _ from 'lodash';
import ChangePass from '@/views/srm/supplier/supplier-register/changePass.vue';
import ChangeBielPass from '@/views/srm/login/changePass.vue';
import { switchLocaleAsync } from '@/lang/index';
import { logout } from '@/utils/logout';
import { langList } from '@/utils/language';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      t
    } = useI18n();
    const changePassRef = ref();
    const changeBielPassRef = ref();
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const menuData = computed(() => $store.state.menu.navMenus.filter(e => !e.Isdetail));
    const showTagsView = computed(() => $store.state.setting.showTagsView);
    const fixedHeader = computed(() => $store.state.setting.fixedHeader);
    const visibleState = ref({
      aside: true
    });
    const isMenuCollapse = ref(false);
    // 选中菜单
    function onMenuItemSelected(index) {
      // 新建流程路由
      if ($route.path && $route.path.startsWith('/flow')) {
        const routeUrl = $router.resolve({
          path: $route.path,
          query: $route.query,
          params: $route.params
        });
        window.open(`${routeUrl.href}?processCode=${$route.meta?.processCode}`, '_black');
      } else {
        $router.push(index);
      }
    }
    // 点击切换侧边栏按钮
    const onToggleAside = () => {
      visibleState.value.aside = !visibleState.value.aside;
    };
    // 是否供应商
    function getSupplierInfo() {
      const supplierEntity = JSON.parse(localStorage.getItem('gys_cur_supplier_info'));
      if (!_.isEmpty(supplierEntity)) {
        return supplierEntity.supplierName;
      } else {
        return '';
      }
    }
    // 获取登陆信息
    function getAcc() {
      const supplierEntity = JSON.parse(localStorage.getItem('gys_cur_supplier_info'));
      const userInfo = JSON.parse(localStorage.getItem('cur_info'));
      if (!_.isEmpty(supplierEntity)) {
        return supplierEntity.supplierName;
      } else if (!_.isEmpty(userInfo)) {
        return userInfo.user;
      } else {
        return '';
      }
    }
    function logoutSys() {
      ElMessageBox.confirm(t('pc-layout-3') + '?', t('msg-2'), {
        confirmButtonText: t('ops-ok'),
        cancelButtonText: t('ops-cancel'),
        type: 'info'
      }).then(() => {
        logout();
      }).catch(() => {});
    }
    function changePass() {
      changePassRef.value.open();
    }
    onBeforeMount(async () => {
      await $store.dispatch('menu/getMenus');
    });
    return (_ctx, _cache) => {
      const _component_Menu = _resolveComponent("Menu");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_document = _resolveComponent("document");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_Expand = _resolveComponent("Expand");
      const _component_Fold = _resolveComponent("Fold");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_header = _resolveComponent("el-header");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createBlock(_component_el_container, {
        class: "main"
      }, {
        default: _withCtx(() => [_withDirectives(_createVNode(_component_el_aside, {
          width: visibleState.value.aside ? '180px' : '0px',
          class: "aside d-flex flex-column"
        }, {
          default: _withCtx(() => [_hoisted_1, _createVNode(_component_el_menu, {
            class: "nav-menu",
            collapse: isMenuCollapse.value,
            "background-color": "#001529",
            "text-color": "#fff",
            "active-text-color": "#fff",
            "unique-opened": true
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuData.value, item => {
              return _openBlock(), _createElementBlock("div", {
                key: item.Abbrflg
              }, [!item.Isleaf ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                key: 0,
                index: item.Abbrflg
              }, {
                title: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_Menu)]),
                  _: 1
                }), _createElementVNode("span", null, _toDisplayString(item.Menuname), 1)]),
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.children, childItem => {
                  return _openBlock(), _createBlock(_component_el_menu_item, {
                    index: childItem.Abbrflg,
                    key: childItem.Abbrflg,
                    onClick: $event => onMenuItemSelected(childItem.Aliasname)
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(childItem.Menuname), 1)]),
                    _: 2
                  }, 1032, ["index", "onClick"]);
                }), 128))]),
                _: 2
              }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 1,
                index: item.Abbrflg,
                onClick: $event => onMenuItemSelected(item.Aliasname)
              }, {
                title: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_document)]),
                  _: 1
                }), _createElementVNode("span", null, _toDisplayString(item.Menuname), 1)]),
                _: 2
              }, 1032, ["index", "onClick"]))]);
            }), 128))]),
            _: 1
          }, 8, ["collapse"])]),
          _: 1
        }, 8, ["width"]), [[_vShow, visibleState.value.aside]]), _createVNode(_component_el_container, null, {
          default: _withCtx(() => [_createVNode(_component_el_header, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
              text: "",
              onClick: _cache[0] || (_cache[0] = $event => onToggleAside())
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, {
                size: "16"
              }, {
                default: _withCtx(() => [!visibleState.value.aside ? (_openBlock(), _createBlock(_component_Expand, {
                  key: 0
                })) : (_openBlock(), _createBlock(_component_Fold, {
                  key: 1
                }))]),
                _: 1
              })]),
              _: 1
            })]), _createElementVNode("div", _hoisted_3, [getAcc() ? (_openBlock(), _createBlock(_component_el_menu, {
              key: 0,
              "background-color": "#001529",
              mode: "horizontal",
              "text-color": "#fff",
              "active-text-color": "#fff",
              ellipsis: false
            }, {
              default: _withCtx(() => [_hoisted_4, _createVNode(_component_el_sub_menu, {
                index: "lang"
              }, {
                title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('language')), 1)]),
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(langList), item => {
                  return _openBlock(), _createBlock(_component_el_menu_item, {
                    key: item.value,
                    index: item.value,
                    onClick: $event => _unref(switchLocaleAsync)(item.value, true)
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                    _: 2
                  }, 1032, ["index", "onClick"]);
                }), 128))]),
                _: 1
              }), _createVNode(_component_el_sub_menu, {
                index: "2"
              }, {
                title: _withCtx(() => [_createTextVNode(_toDisplayString(getAcc()), 1)]),
                default: _withCtx(() => [getSupplierInfo() ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 0,
                  index: "2-1",
                  onClick: changePass
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('pc-layout-1')), 1)]),
                  _: 1
                })) : _createCommentVNode("", true), _createVNode(_component_el_menu_item, {
                  index: "2-2",
                  onClick: logoutSys
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('pc-layout-2')), 1)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(ChangePass, {
              ref_key: "changePassRef",
              ref: changePassRef
            }, null, 512), _createVNode(ChangeBielPass, {
              ref_key: "changeBielPassRef",
              ref: changeBielPassRef
            }, null, 512)])]),
            _: 1
          }), _createVNode(_component_el_main, {
            class: "container"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass({
                'fixed-header': fixedHeader.value
              })
            }, [showTagsView.value ? (_openBlock(), _createBlock(_unref(TagsView), {
              key: 0
            })) : _createCommentVNode("", true)], 2), _createVNode(_unref(AppMain))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
});